import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import Panel from '@/client/components/_atoms/Panel.vue'
import { InstagramInstantwinPretestEntryCode } from '@/typings/api/instagram_instantwin_pretest_entry_codes.schema'

import { getInstagramDmTestLotteryResultLabel } from '../../utils/instagramDmTest'

interface Props {
  current: InstagramInstantwinPretestEntryCode
  panelState: 'active' | 'expired'
  disabled: boolean
  remainingMinutes: number
}

interface Emits {
  (e: 'copy', code: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramDmTestCodePanel',
  props: {
    current: null,
    panelState: null,
    disabled: { type: Boolean },
    remainingMinutes: null
  },
  emits: ["copy"],
  setup(__props: any) {

const props = __props as {
  current: InstagramInstantwinPretestEntryCode
  panelState: 'active' | 'expired'
  disabled: boolean
  remainingMinutes: number
};




const lotteryResultLabel = computed(() => getInstagramDmTestLotteryResultLabel(props.current.lotteryResult))
const remainingTimeText = computed(() => {
  const minutes = props.remainingMinutes
  if (minutes < 60) {
    return `${minutes} 分`
  }
  const hours = Math.floor(minutes / 60)
  const remainMinutes = minutes % 60
  return remainMinutes > 0 ? `${hours} 時間 ${remainMinutes} 分` : `${hours} 時間`
})
const headerText = computed(() =>
  props.panelState === 'active' ? 'テストコード発行済み' : 'テストコードの有効期限が切れました'
)
const headerColor = computed(() => (props.panelState === 'active' ? 'success' : 'warning'))

return { __sfc: true,props, lotteryResultLabel, remainingTimeText, headerText, headerColor, Icon, Panel }
}

})